import { AxiosInstance } from "axios";
import { Dispatch } from "redux";
import { IPlan } from "../../../../common/types";
import { IStateTree } from "../../interfaces";
import { showNotification } from "../../notification/actions";
import { RecentPlansActionTypes } from "../models/recentPlansActions";
import { GET_RECENT_PLANS } from "../types";

export default () => async (dispatch: Dispatch<RecentPlansActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    try {
        const res = await api.get<{ plans: IPlan[] }>("/recent-public-plans");
        dispatch({
            type: GET_RECENT_PLANS,
            payload: res,
        });
    } catch (error) {
        dispatch(showNotification(error.toString(), "warning"));
    }
};
